import { render, staticRenderFns } from "./forget-sec-password.vue?vue&type=template&id=3fd278dc"
import script from "./forget-sec-password.vue?vue&type=script&lang=js"
export * from "./forget-sec-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports